import { render, staticRenderFns } from "./maillistdetails.vue?vue&type=template&id=441cb430&scoped=true&"
import script from "./maillistdetails.vue?vue&type=script&lang=js&"
export * from "./maillistdetails.vue?vue&type=script&lang=js&"
import style0 from "./maillistdetails.vue?vue&type=style&index=0&id=441cb430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441cb430",
  null
  
)

export default component.exports